export const FETCH_FILTER_SETTING_FEE_HISTORY = 'FETCH_FILTER_SETTING_FEE_HISTORY';
export const FETCH_FILTER_SETTING_FEE_HISTORY_SUCCEED = 'FETCH_FILTER_SETTING_FEE_HISTORY_SUCCEED';
export const FETCH_FILTER_SETTING_FEE_HISTORY_FAILED = 'FETCH_FILTER_SETTING_FEE_HISTORY_FAILED';
